import {
  START_DATE_CHANGE,
  END_DATE_CHANGE
} from '../constants/action_types';

export const startDateChange = (startDate = '') => ({
  type: START_DATE_CHANGE,
  startDate
});

export const endDateChange = (endDate = '') => ({
  type: END_DATE_CHANGE,
  endDate
});



// WEBPACK FOOTER //
// ./src/actions/filter_by_date_actions.js